import { Component, OnInit, inject } from '@angular/core';
import { Client } from '../../../core/models/client.model';
import { ClientsService } from '../../../core/services/clients.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ClientFormMode, ClientFormComponent } from '../../components/client-form/client-form.component';

import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-capture-admin-client-edit',
    templateUrl: './capture-admin-client-edit.component.html',
    styleUrls: ['./capture-admin-client-edit.component.scss'],
    imports: [RouterLink, ClientFormComponent, MatProgressSpinner]
})
export class CaptureAdminClientEditComponent implements OnInit {
  private clientsService = inject(ClientsService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  client: Client;
  loading = false;
  formModes = ClientFormMode;
  uploading = false;

  ngOnInit() {
    this.init();
  }

  private init() {
    const clientId = this.route.snapshot.paramMap.get('id');
    this.loadClient(clientId);
  }

  private loadClient(clientId): void {
    this.loading = true;
    this.clientsService.get(clientId).subscribe(
      client => {
        this.client = client;
        this.loading = false;
      },
      (err: HttpErrorResponse) => {
        if (err.status === 404) {
          this.router.navigate(['/404'], { replaceUrl: true });
        } else {
          console.error(err);
        }
      }
    );
  }
}
